export enum BuyOfferTestIds {
    FAB = "buy_offer_fab"
}